// core/data/posts.ts — typed seed for the post feed.
//
// Faithfully ported from legacy src/scripts/data/posts.js.
// IMPORTANT: All engagement counts are stored as integers.
// Legacy display strings (e.g. '1.2K', '846') are converted to integers here.
// Formatting for display (1200 → '1.2K') is a display-layer concern.
//
// Handle/author casing matches legacy exactly so post-card denormalized fields
// are consistent with the users registry (e.g. '@WayneTech').

import type { Post } from '@/core/models/post';

export const seedPosts: Post[] = [
  {
    id: 'post-001',
    authorId: 'freedom-seeker',
    name: 'FreedomSeeker',
    handle: '@FreedomSeeker',
    av: 'av-1',
    verified: true,
    time: '2h',
    body: "The truth doesn't need permission.<br/>It just needs to be spoken.<br/><a class=\"tag\" href=\"#\">#SpeakFreely</a>",
    media: 'cityscape',
    comments: 128,
    cheers: 342,
    spreads: 0,
    likes: 1200, // legacy '1.2K'
    liked: true,
    cheered: false,
  },
  {
    id: 'post-002',
    authorId: 'liberty-mind',
    name: 'LibertyMind',
    handle: '@LibertyMind',
    av: 'av-2',
    verified: true,
    time: '4h',
    body: "Question everything. Think freely.<br/>Don't let anyone silence your mind.<br/><a class=\"tag\" href=\"#\">#TruthMatters</a>",
    comments: 87,
    cheers: 201,
    spreads: 0,
    likes: 846,
    liked: true,
    cheered: false,
  },
  {
    id: 'post-003',
    authorId: 'open-mind',
    name: 'OpenMind',
    handle: '@OpenMindX',
    av: 'av-3',
    verified: true,
    time: '6h',
    body: "Real conversations build real communities.<br/>What's a belief you've changed your mind about?<br/><a class=\"tag\" href=\"#\">#OpenDialogue</a>",
    comments: 54,
    cheers: 96,
    spreads: 0,
    likes: 512,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-004',
    authorId: 'wayne-tech',
    name: 'WayneTech',
    handle: '@WayneTech',
    av: 'av-grad',
    verified: true,
    time: '2h',
    body: "Freedom isn't just a right. It's the foundation of truth and progress.<br/>Protect it. Defend it. Live it.<br/><a class=\"tag\" href=\"#\">#Freedom</a>",
    comments: 64,
    cheers: 188,
    spreads: 0,
    likes: 1400, // legacy '1.4K'
    liked: false,
    cheered: false,
  },
  {
    id: 'post-005',
    authorId: 'wayne-tech',
    name: 'WayneTech',
    handle: '@WayneTech',
    av: 'av-grad',
    verified: true,
    time: '4h',
    body: "Decentralization is the path to digital sovereignty.<br/>The future is in our hands. Let's build it together.<br/><a class=\"tag\" href=\"#\">#BuildFreely</a>",
    media: 'globe',
    comments: 42,
    cheers: 121,
    spreads: 0,
    likes: 987,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-006',
    authorId: 'freedom-seeker',
    name: 'FreedomSeeker',
    handle: '@FreedomSeeker',
    av: 'av-1',
    verified: true,
    time: '3h',
    body: "Sunlight is the best disinfectant.<br/>Transparency isn't optional. It's the whole point.<br/><a class=\"tag\" href=\"#\">#Transparency</a>",
    media: 'globe',
    comments: 31,
    cheers: 88,
    spreads: 0,
    likes: 612,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-007',
    authorId: 'liberty-mind',
    name: 'LibertyMind',
    handle: '@LibertyMind',
    av: 'av-2',
    verified: true,
    time: '5h',
    body: "Cities are arguments made of steel.<br/>Build ones worth living in.<br/><a class=\"tag\" href=\"#\">#Ideas</a>",
    media: 'cityscape',
    comments: 47,
    cheers: 133,
    spreads: 0,
    likes: 901,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-008',
    authorId: 'open-mind',
    name: 'OpenMind',
    handle: '@OpenMindX',
    av: 'av-3',
    verified: true,
    time: '7h',
    body: "The best conversations change everyone in them.<br/>Stay curious.<br/><a class=\"tag\" href=\"#\">#OpenDialogue</a>",
    comments: 22,
    cheers: 64,
    spreads: 0,
    likes: 388,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-009',
    authorId: 'wayne-tech',
    name: 'WayneTech',
    handle: '@WayneTech',
    av: 'av-grad',
    verified: true,
    time: '8h',
    body: "Shipped a new build tonight.<br/>Tools should disappear into the work.<br/><a class=\"tag\" href=\"#\">#BuildFreely</a>",
    media: 'cityscape',
    comments: 58,
    cheers: 174,
    spreads: 0,
    likes: 1100, // legacy '1.1K'
    liked: false,
    cheered: false,
  },
  {
    id: 'post-010',
    authorId: 'maya-patel',
    name: 'Maya Patel',
    handle: '@mayap',
    av: 'av-2',
    verified: false,
    time: '9h',
    body: "Found a bug. Reported it. Slept fine.<br/>Responsible disclosure is a love language.<br/><a class=\"tag\" href=\"#\">#AppSec</a>",
    comments: 19,
    cheers: 52,
    spreads: 0,
    likes: 274,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-011',
    authorId: 'jordan-lee',
    name: 'Jordan Lee',
    handle: '@jlee',
    av: 'av-4',
    verified: true,
    time: '11h',
    body: "Maintained open source for 6 years.<br/>The internet runs on volunteers and coffee.<br/><a class=\"tag\" href=\"#\">#OpenSource</a>",
    media: 'globe',
    comments: 73,
    cheers: 244,
    spreads: 0,
    likes: 2100, // legacy '2.1K'
    liked: false,
    cheered: false,
  },
  {
    id: 'post-012',
    authorId: 'sara-kim',
    name: 'Sara Kim',
    handle: '@sarak',
    av: 'av-5',
    verified: false,
    time: '12h',
    body: "Design is deciding what to leave out.<br/>Every pixel earns its place.<br/><a class=\"tag\" href=\"#\">#Design</a>",
    comments: 16,
    cheers: 71,
    spreads: 0,
    likes: 430,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-013',
    authorId: 'wayne-tech',
    name: 'WayneTech',
    handle: '@WayneTech',
    av: 'av-grad',
    verified: true,
    time: '1d',
    body: "Freedom scales better than control.<br/>Always has.<br/><a class=\"tag\" href=\"#\">#Freedom</a>",
    comments: 39,
    cheers: 207,
    spreads: 0,
    likes: 1600, // legacy '1.6K'
    liked: false,
    cheered: false,
  },
  {
    id: 'post-014',
    authorId: 'freedom-seeker',
    name: 'FreedomSeeker',
    handle: '@FreedomSeeker',
    av: 'av-1',
    verified: true,
    time: '1d',
    body: "Filed three stories this week.<br/>Hold power to account, every single day.<br/><a class=\"tag\" href=\"#\">#FreePress</a>",
    media: 'cityscape',
    comments: 44,
    cheers: 96,
    spreads: 0,
    likes: 733,
    liked: false,
    cheered: false,
  },
  {
    id: 'post-015',
    authorId: 'liberty-mind',
    name: 'LibertyMind',
    handle: '@LibertyMind',
    av: 'av-2',
    verified: true,
    time: '2d',
    body: "Read something you disagree with today.<br/>Then steelman it.<br/><a class=\"tag\" href=\"#\">#ThinkFreely</a>",
    comments: 28,
    cheers: 119,
    spreads: 0,
    likes: 655,
    liked: false,
    cheered: false,
  },
];
